
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import { FACT_FILE_INDEX } from '@constants/routes';
import AnchorLink from '@components/AnchorLink';
import { trackClickEvent } from '@utils/analytics';
import { FILTER_CATEGORIES_DATA } from '@constants/index';
import s from './Breadcrumbs.module.scss';
const propTypes = {
    category: PropTypes.string.isRequired,
    analyticsParams: PropTypes.shape({}).isRequired
};
const Breadcrumbs = ({ category, analyticsParams }) => {
    const categoryName = FILTER_CATEGORIES_DATA.find((filter) => filter.slug === category)?.name;
    const categoryLink = `${FACT_FILE_INDEX}/${category}`;
    const handleAllFactFilesClick = () => {
        trackClickEvent({
            destination_url: FACT_FILE_INDEX,
            label: 'Breadcrumb - All Fact Files',
            location: 'Breadcrumbs',
            vertical_index: 2,
            horizontal_index: 0,
            ...analyticsParams
        });
    };
    const handleCategoryClick = () => {
        trackClickEvent({
            destination_url: categoryLink,
            label: `Breadcrumb - ${categoryName}`,
            location: 'Breadcrumbs',
            vertical_index: 2,
            horizontal_index: 1,
            ...analyticsParams
        });
    };
    return (<div className={s.root}>
      <AnchorLink href={FACT_FILE_INDEX} className={s.link} onClick={handleAllFactFilesClick} data-testid="all-fact-files">
        All Fact Files
      </AnchorLink>
      <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5574 6.65252L0.664062 10.2575M6.50406 6.05194L0.664062 0.644531" stroke="#C2BBFF" strokeWidth="1.2"/>
      </svg>
      <AnchorLink href={categoryLink} className={s.link} onClick={handleCategoryClick} data-testid="category-link">
        {categoryName}
      </AnchorLink>
    </div>);
};
Breadcrumbs.propTypes = {};
Breadcrumbs.propTypes = propTypes;
export default Breadcrumbs;

    async function __Next_Translate__getStaticProps__195ca0caf2e__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFile/components/Breadcrumbs/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0caf2e__ as getStaticProps }
  